import { api_routes } from './api-routes.js';

var API_BASE = process.env.VUE_APP_API_BASE || 'https://apiteatros.dev.compralaentrada.com/api1';

var API_TEATROS = process.env.VUE_APP_API_TEATROS || 'https://apiteatros.dev.compralaentrada.com/';

var LOCAL_BASE = '/';

var CLE = process.env.VUE_APP_CLE || 'https://www.dev.compralaentrada.com/';

const TIMEZONE = process.env.VUE_APP_TIMEZONE;

var DEPORTES = 1;
var TEATROS = 2;


export var config = {
    DEPORTES,
    TEATROS,
    API_TEATROS,
    API_BASE,
    CLE,
    LOCAL_BASE,
    IMPRIMIR_URL : API_BASE + '/eventos/%EVENTO_ID%/estado/%SESION_ID%/entradas/imprimir',
    getAPIRoute : getAPIRoute,
    getVuexAlias : getVuexAlias,
    getAPIRoutes : getAPIRoutes,
    OFFLINE_MODE : false,
    TIMEZONE,
    CURRENCY: ['es-ES', {style: 'currency', currency: 'EUR'}],
}

/*
	in vuex we store the name of the method in the module (in store/modules)
	in api we store the name of the api endpoint
*/

function getAPIRoute(key){
    return api_routes[key];
}

function getAPIRoutes() {
    return api_routes;
}

function getVuexAlias(key){
    return api_routes[key].vuex;
}
